import * as Yup from 'yup';

export const addContactUsFormValidationSchema = Yup.object().shape({
        first_name: Yup.string().required('Required'),
        last_name : Yup.string().required('Required'),
        your_notes: Yup.string().required('Required'),
        location_id : Yup.string().required('Required'),
        email: Yup.string()
              // .email("Enter a valid email")
              .required("Email/Phone Number is required")
              .test('test-name', 'Enter Valid Phone/Email',
                function(value) {
                  const emailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

                  const phoneRegex = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/; // Change this regex based on requirement
                  // const phoneRegex = /^(\+91-|\+91|0)?\d{10}$/; // Change this regex based on requirement
                  let isValidEmail = emailRegex.test(value);
                  let isValidPhone = phoneRegex.test(value);
                  if (!isValidEmail && !isValidPhone ){
                    return false;
                  }
                  return true;
              }),
              radio : Yup.string().required('Required'),
});

export const emailSubsFormValidationSchema = Yup.object().shape({
        email: Yup.string().email().required('Email is required')
});

export const emailSubsFormValidationSchemaForCampaingAndFooterModal =
  Yup.object().shape({
    email: Yup.string()
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Enter a valid email"
      )
      .required("Email address is required"),
  });

export const emailSubsFormValidationSchemaForInAppMessage = Yup.object().shape({
        email: Yup.string()
        .email("Enter a valid email")
        .required("Email address is required")    
        .test("no-alias", `The email address must not contain a "+" character`, (value) => {
        if (!value) return true; // Skip if empty (handled by required)
        return !value.includes("+"); // Check for email alias
        })
        .test("no-private-relay", "Please enter a valid email address", (value) => {
        if (!value) return true; // Skip if empty (handled by required)
        return !value.toLowerCase().includes("privaterelay"); // Check for private relay
        }),
});

export const complimentAndConcernFormValidationSchema = Yup.object().shape({
        feedback: Yup.string().required('Required'),
        location_id: Yup.string().required('Required'),
        team_member: Yup.string().required('Required')
});
